import React from 'react'

import { Icon, Search } from "@cgtrader/triangle-ui/dist/src/ssr-index"
import { func, string, shape } from 'prop-types'

function SearchInput({ inputRef = null, searchTerm, onChange }) {
  return (
    <div className="custom-searchable-select__search">
      <div className="custom-searchable-select__search-wrapper">
        <Icon
          svgComponent={Search}
          color="dark"
          className="custom-searchable-select__search-icon"
        />
        <input
          ref={inputRef}
          type="text"
          value={searchTerm}
          onChange={onChange}
          placeholder="Type in to search..."
          className="custom-searchable-select__search-input"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  )
}

SearchInput.propTypes = {
  inputRef: shape({ current: shape({}) }),
  searchTerm: string.isRequired,
  onChange: func.isRequired,
}

export default SearchInput
